<rms-carousel [list]="yearsListSet"
              [initialSelectedValue]="initialValue"
              (yearSelected)="onYearSelected($event)">
</rms-carousel>
<hr>
<div class="rounded-items-list mt-4">
  <ng-template ngFor let-item let-i="index" [ngForOf]="quarterList">
    <span (click)="selectQuarter(item)" [class.active]="item.selected">{{item.name}}</span>
    <div class="divider" *ngIf="i === 7"></div>
  </ng-template>
</div>
